import Immutable from "immutable";

export default {
    UPDATE_ROUTES: (state, action) => {
        var path = action.payload.path;
        if (state.get("routes")) {
            var routes = state.get("routes");
            //routes should contain all visited urls
            //instead of all different visited urls
            if (routes.last() !== path) {
                routes = routes.push(path);
            }
            state = state.setIn(["routes"], routes);
            return state.set("current", path);
        } else {
            return state.merge(Immutable.fromJS({ current: path, routes: [path] }));
        }
    },
    SET_ROOT_PATH: (state, action) => {
        return state.set("rootPath", action.payload.path);
    },
    "@@router/LOCATION_CHANGE": (state, action) => {
        return state.set("location", Immutable.fromJS(action.payload));
    }
};
